import { combineReducers } from 'redux'
import { default as reducerCsrf } from 'redux-csrf'
import { signUpMembers, resendEmailMembers } from './Authentification/SignUpMembers'
import { signInMembers, verifiedEmailMembers, tokenExpireMembers } from './Authentification/SignInMembers'
import { signInCourtiers } from './Authentification/SignInCourtiers'
import { reauthenticateMembers } from './Authentification/Reauthenticate'
import { reauthenticateCourtiers } from './Authentification/ReauthenticateCourtiers'
import { logoutMembers } from './Authentification/Logout'
import { downloadDevisLogoCourtier } from './Simulation/Devis'
import { getSouscripteur, addSouscripteur, updateSouscripteur, sendMailToSouscripteur } from './Souscription/Souscripteur'
import { getBeneficiaires, addBeneficiaire, updateBeneficiaire, removeBeneficiaire } from './Souscription/Beneficiaire'
import { addQuestionnaire } from './Souscription/Questionnaire'
import { getAllClicks, getAllSouscriptions, getWeekSouscriptions, getActivatedPolicies } from './Parrain'
import { updateUserDataMembers, updateUserPasswordDataMembers } from './Reglages/MembersData'
import { reducer as formReducer } from 'redux-form'

const reducers = {
  _csrf: reducerCsrf,
  form: formReducer,
  signUpMembers,
  resendEmailMembers,
  signInMembers,
  signInCourtiers,
  logoutMembers,
  verifiedEmailMembers,
  tokenExpireMembers,
  reauthenticateMembers,
  reauthenticateCourtiers,
  getSouscripteur,
  addSouscripteur,
  updateSouscripteur,
  sendMailToSouscripteur,
  getBeneficiaires,
  addBeneficiaire,
  updateBeneficiaire,
  removeBeneficiaire,
  getAllClicks,
  getAllSouscriptions,
  getWeekSouscriptions,
  getActivatedPolicies,
  addQuestionnaire,
  updateUserDataMembers,
  updateUserPasswordDataMembers,
  downloadDevisLogoCourtier,
}
export default combineReducers(reducers)



// WEBPACK FOOTER //
// ./src/reducers/index.js